// @flow
import IconSave from 'app/common/ui-next/plain-editable-prop/icons/icon-save';

export default IconSave;
